import * as React from "react";
import * as ReactDOM from "react-dom";
import "./css/site.css";
import registerServiceWorker from "./registerServiceWorker";

import AppRouter from "./router";

ReactDOM.render(
    <AppRouter />,
    document.getElementById("root")
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx